import { render, staticRenderFns } from "./selfbuiltorder.vue?vue&type=template&id=f65d7f06&"
import script from "./selfbuiltorder.vue?vue&type=script&lang=js&"
export * from "./selfbuiltorder.vue?vue&type=script&lang=js&"
import style0 from "./selfbuiltorder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports